export class ProfessionHelper {
    static isPainting(id) {
        return (id === 1);
    }
    static isMusic(id) {
        return (id === 2);
    }
}
